<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <div class="hd z-flex z-flex-between">
            <div class="hd-t"><i class="el-icon-wallet"></i>我的优惠券</div>
            <el-button type="primary" size="medium" @click="showDialogGetCoupon = true">领取新优惠券</el-button>
          </div>
          <div class="bd z-flex z-flex-between">
            <div :class="['item',item.sta=='isExpired'?'item-gery':'']" v-for="(item,index) in couponList" :key="index">
              <div class="item-top z-flex z-flex-between">
                <div class="item-top-l">
                  <div class="title">{{item.title}}</div>
                  <div class="use-time">{{item.useTime}}</div>
                </div>
                <div class="item-top-r">
                  <div class="discount-price"><span>￥</span>{{item.discountPrice}}</div>
                  <div class="use-price">满{{item.usePrice}}可用</div>
                </div>
              </div>
              <div class="break"></div>
              <div class="item-bottom z-flex z-flex-between">
                <div class="desc">
                  <el-collapse>
                    <el-collapse-item title="详细说明">
                      <div v-html="item.desc"></div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
                <div class="btn">
                  <el-button size="medium" round type="primary" @click="toUrl(item)" v-if="item.sta=='canUse'">去使用</el-button>
                  <el-button size="medium" round type="primary" disabled v-if="item.sta=='isUsed'">已使用</el-button>
                  <el-button size="medium" round type="primary" disabled v-if="item.sta=='isExpired'">已过期</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 领取优惠券 -->
    <el-dialog
      class="dialog-getcoupon"
      title="领取优惠券"
      :visible.sync="showDialogGetCoupon"
      width="480px"
    >
      <div class="get-coupon-list">
        <div class="item" v-for="(item,index) in getCouponList" :key="index">
          <div class="item-top z-flex z-flex-between">
            <div class="item-top-l">
              <div class="title">{{item.title}}</div>
              <div class="use-time">{{item.useTime}}</div>
            </div>
            <div class="item-top-r">
              <div class="discount-price"><span>￥</span>{{item.discountPrice}}</div>
              <div class="use-price">满{{item.usePrice}}可用</div>
            </div>
          </div>
          <div class="break"></div>
          <div class="item-bottom z-flex z-flex-between">
            <div class="desc">
              <el-collapse>
                <el-collapse-item title="详细说明">
                  <div v-html="item.desc"></div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <el-button class="btn-get" size="mini" round type="primary" v-if="!item.isGet" @click="get(item)">领取</el-button>
            <el-button class="btn-get btn-isget" size="mini" round type="primary" disabled v-else>已领取</el-button>
          </div>
        </div>
        <el-empty description="暂无可使用的优惠券" v-if="getCouponList==0"></el-empty>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogGetCoupon = false">取 消</el-button>
        <el-button type="primary" @click="getAll">全部领取</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
export default {
  components: {
    myLeft,
    myTop,
  },
  data() {
    return {
      couponList:[],
      showDialogGetCoupon:false,
      getCouponList:[
        // {
        //   title:'摄影采风专用券',
        //   discountPrice:100,//抵扣金额
        //   usePrice:999,//起用金额
        //   useTime:'2022.05.01-2022.08.01',//使用时间
        //   desc:`该券为满减券，券前金额满100减10元<br>指定摄影采风可用<br>优惠券最终解释权归千途所有`,
        //   isGet:false,
        // },{
        //   title:'摄影采风专用券',
        //   discountPrice:100,//抵扣金额
        //   usePrice:999,//起用金额
        //   useTime:'2022.05.01-2022.08.01',//使用时间
        //   desc:`该券为满减券，券前金额满100减10元<br>指定摄影采风可用<br>优惠券最终解释权归千途所有`,
        //   isGet:false,
        // },{
        //   title:'摄影采风专用券',
        //   discountPrice:100,//抵扣金额
        //   usePrice:999,//起用金额
        //   useTime:'2022.05.01-2022.08.01',//使用时间
        //   desc:`该券为满减券，券前金额满100减10元<br>指定摄影采风可用<br>优惠券最终解释权归千途所有`,
        //   isGet:true,
        // },
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getList();
  },
  methods: {
    toUrl(item){
      let url = '';
      if(item.useObject == 'ps'){
        url = '/ps/index';
      }else{
        url = '/'+ item.useObject +'/list';
      }
      this.$router.push({
        path:url,
      })
    },
    get(item){
      this.$set(item,'isGet',true);
      this.$message.success('领取成功！');
    },
    getAll(){

    },
    getList(){
      this.$axios.api.request({
        url: "/api/qtclub/user/getCouponList",
        method: "GET",
        data: {
          offset: 0,
          length: 100,
        }
      }, (res) => {
        this.couponList = res.data.list;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.my-box{
  padding:20px;
  .hd{
    margin-bottom: 25px;
    .hd-t{
      font-size: 18px;
      i{
        margin-right: 10px;
        color: $colorMain;
      }
    }
  }
  .bd{
    align-items: flex-start;
    .item{
      width: calc(50% - 10px);
      margin-bottom: 20px;
      padding: 20px;
      background-color: #fef0f0;
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      .item-top{
        // border-bottom: 1px dashed #fb848d;
        padding-bottom: 20px;
        flex-wrap: wrap;
        .item-top-l{
          flex: 1;
          margin-right: 20px;
          @extend %textOverflow;
          .title{
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 20px;
            @extend %textOverflow;
          }
          .use-time{
            font-size: 16px;
            color: #999;
          }
        }
        .item-top-r{
          text-align: center;
          color: $colorMain;
          .discount-price{
            font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-size: 38px;
            span{
              font-size: 18px;
            }
          }
          .use-price{
            font-size: 18px;
          }
        }
      }
      .break{
        width: 100%;
        height:1px;
        border-bottom: 1px dashed #fb848d;
        position: relative;
        &::before{
          content: "";
          width:30px;
          height:30px;
          background: #fff;
          display: block;
          border-radius: 100%;
          position: absolute;
          left: -35px;
          top: 50%;
          margin-top: -15px;
        }
        &::after{
          content: "";
          width:30px;
          height:30px;
          background: #fff;
          display: block;
          border-radius: 100%;
          position: absolute;
          right: -35px;
          top: 50%;
          margin-top: -15px;
        }
      }
      .item-bottom{
        align-items: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
        .desc{
          flex: 1;
          margin-right: 20px;
          ::v-deep .el-collapse{
            border:none;
            .el-collapse-item__arrow{
              margin: 0;
            }
          }
          ::v-deep .el-collapse-item__header{
            background:none;
             border:none;
             height: 36px;
             line-height: 36px;
             justify-content: flex-start;
          }
          ::v-deep .el-collapse-item__wrap{
            background:none;
            border:none;
          }
          ::v-deep .el-collapse-item__content{
            padding-bottom: 0;
          }
        }
      }
      &.item-gery{
        filter: grayscale(100%);
      }
    }
  }
}
.dialog-getcoupon{
  ::v-deep .el-dialog__body{
    padding: 20px;
    max-height: 500px;
    overflow-y: auto;
  }
  .get-coupon-list{
    .item{
      width: 100%;
      margin-bottom: 20px;
      padding: 10px 20px;
      background-color: #fef0f0;
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      cursor: pointer;
      .item-top{
        padding-bottom: 10px;
        flex-wrap: wrap;
        .item-top-l{
          flex: 1;
          margin-right: 10px;
          @extend %textOverflow;
          .title{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
            @extend %textOverflow;
          }
          .use-time{
            font-size: 13px;
            color: #999;
          }
        }
        .item-top-r{
          text-align: center;
          color: $colorMain;
          .discount-price{
            font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-size: 28px;
            span{
              font-size: 15px;
            }
          }
          .use-price{
            font-size: 14px;
          }
        }
      }
      .break{
        width: 100%;
        height:1px;
        border-bottom: 1px dashed #fb848d;
      }
      .item-bottom{
        align-items: flex-start;
        flex-wrap: wrap;
        padding-top: 10px;
        .btn-get{
          padding: 7px 22px;
          &.btn-isget{
            background-color: #ec8090;
            border-color: #ec8090;
            cursor: not-allowed;
          }
        }
        .desc{
          flex: 1;
          margin-right: 20px;
          ::v-deep .el-collapse{
            border:none;
            .el-collapse-item__arrow{
              margin: 0;
            }
          }
          ::v-deep .el-collapse-item__header{
            background:none;
             border:none;
             height: 36px;
             line-height: 36px;
             justify-content: flex-start;
          }
          ::v-deep .el-collapse-item__wrap{
            background:none;
            border:none;
          }
          ::v-deep .el-collapse-item__content{
            padding-bottom: 0;
          }
        }
      }
      &.item-gery{
        filter: grayscale(100%);
      }
    }
  }
}
</style>
